import { axios } from '@/utils/request'

const api = {
  accessory: '/stock/accessory'
}

const api2 = {
  accessory: '/stock/config'
}

const api3 = {
  accessory: '/stock/selectutils'
}

const api4 = {
  management: '/enterprise/management'
}

// 查询品牌
export function selectbrand(parameter) {
  return axios({
    url: api3.accessory + '/selectbrand',
    method: 'get',
    params: parameter
  })
}

// 查询型号
export function selectmodel(parameter) {
  return axios({
    url: api3.accessory + '/selectmodel',
    method: 'get',
    params: parameter
  })
}

export function getAccessoryList(parameter) {
  return axios({
    url: api.accessory + '/accessorylist',
    method: 'get',
    params: parameter
  })
}

export function saveAccessory(parameter) {
  return axios({
    url: api.accessory + '/addaccessory',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function editaccessory(parameter) {
  return axios({
    url: api.accessory + '/editaccessory',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function delAccessory1(parameter) {
  return axios({
    url: api.accessory + '/delaccessory',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function delAccessoryTwo(parameter) {

  return axios({
    url: api.accessory + '/forbidden',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 企业关联
export function configAccessoryEnterprise(parameter) {
  return axios({
    url: api.accessory + '/configAccessoryEnterprise',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 配置关联
export function configAccessoryModel(parameter) {
  return axios({
    url: api.accessory + '/configAccessoryModel',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function selAccessory(parameter) {
  return axios({
    url: api.accessory + '/getoneaccessory',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function selectenterprise(parameter) {
  return axios({
    url: api3.accessory + '/selectenterprise',
    method: 'get',
    params: parameter

  })
}

export function selectenterprise2(parameter) {
  return axios({
    url: api3.accessory + '/selectconfigmodel',
    method: 'get',
    params: parameter

  })
}
export function selectenterprise3(parameter) {
  return axios({
    url: '/exam/model/list',
    method: 'get',
    params: parameter

  })
}

// 企业
export function getSelectTree(parameter) {
  return axios({
    url: api4.management + '/selectTree',
    method: 'get',
    params: parameter
  })
}
export const accessoryExport = api.accessory + '/export'
